//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

export interface IInstagramAutocompleteResponse {
  data: IInstagramSourceAndCountData;
}

export interface IInstagramSourceAndCountData {
  hashtags: IInstagramSourceAndCount[];
  usernames: IInstagramSourceAndCount[];
  labels: IInstagramSourceAndCount[];
}

export interface IInstagramSourceAndCount {
  source: string;
  count: number;
}

export interface IInstagramSourceAndCountWithAutocomplete
  extends IInstagramSourceAndCount {
  group: AutocompleteGroup;
}

export enum AutocompleteGroup {
  HASHTAG = 'Hashtags',
  USERNAMES = 'Usernames',
}
